const state = {
  routes: [], // 存储格式化后的菜单路由
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes;
  },
  RESET_ROUTES: (state) => {
    state.routes = [];
  },
};

const getters = {
  routes: (state) => state.routes,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
